// extracted by mini-css-extract-plugin
export default {"dialogueContainer":"MascotteComponent_dialogueContainer__8LzWU","mascotteContainer":"MascotteComponent_mascotteContainer__fagu-"};